import React from 'react';
import { Mic, HeadphonesIcon, ArrowRight, Users } from 'lucide-react';

const MediaSection = () => {
  const handleFollowMovement = () => {
    console.log('Following the movement - redirect to social media');
    // In real implementation: window.open('https://instagram.com/BrownishhOfficial', '_blank');
  };

  return (
    <section id="media" className="py-20 bg-warmCream">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-black text-richBrown mb-6 tracking-tight">
            Media & Culture
          </h2>
          <p className="text-xl text-warmBrown max-w-3xl mx-auto leading-relaxed">
            A platform for the culture, by the culture. Real stories, raw conversations, 
            and content that celebrates who we are.
          </p>
          <div className="w-24 h-1 bg-goldAccent mx-auto mt-6"></div>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <Mic className="w-6 h-6 text-goldAccent" />
              <span className="text-goldAccent font-bold text-sm tracking-widest uppercase">Coming Soon</span>
            </div>
            
            <h3 className="text-3xl sm:text-4xl font-black text-richBrown mb-6 tracking-wide">
              The #Brownishh
              <br />
              <span className="text-goldAccent">Movement</span>
            </h3>
            
            <p className="text-warmBrown text-lg leading-relaxed mb-6">
              Real stories. Raw conversations. A platform for the culture, by the culture.
            </p>

            <div className="space-y-4 mb-8">
              <div className="flex items-start gap-3">
                <div className="w-2 h-2 bg-goldAccent rounded-full mt-3"></div>
                <div>
                  <h4 className="font-bold text-richBrown mb-1">Authentic Conversations</h4>
                  <p className="text-warmBrown">Real talk about identity, beauty standards, and cultural pride</p>
                </div>
              </div>
              
              <div className="flex items-start gap-3">
                <div className="w-2 h-2 bg-goldAccent rounded-full mt-3"></div>
                <div>
                  <h4 className="font-bold text-richBrown mb-1">Community Stories</h4>
                  <p className="text-warmBrown">Celebrating brown women who are changing the narrative</p>
                </div>
              </div>
              
              <div className="flex items-start gap-3">
                <div className="w-2 h-2 bg-goldAccent rounded-full mt-3"></div>
                <div>
                  <h4 className="font-bold text-richBrown mb-1">Cultural Movement</h4>
                  <p className="text-warmBrown">Building a standard that celebrates our heritage</p>
                </div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              <button 
                onClick={handleFollowMovement}
                className="group bg-richBrown hover:bg-goldAccent text-warmCream hover:text-richBrown font-bold py-3 px-6 rounded-none transition-all duration-300 flex items-center gap-2 tracking-wide"
              >
                <Users className="w-5 h-5" />
                FOLLOW THE MOVEMENT
                <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform duration-300" />
              </button>
              
              <button className="group border-2 border-richBrown text-richBrown hover:bg-richBrown hover:text-warmCream font-bold py-3 px-6 rounded-none transition-all duration-300 flex items-center gap-2 tracking-wide">
                OWN THE NARRATIVE
              </button>
            </div>
          </div>

          <div className="relative">
            <div className="aspect-square bg-gradient-to-br from-warmBrown to-deepBrown rounded-lg overflow-hidden relative">
              <img 
                src="https://images.unsplash.com/photo-1589903308904-1010c2294adc?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80"
                alt="Media Platform Coming Soon"
                className="w-full h-full object-cover opacity-60"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-richBrown/80 to-transparent"></div>
              
              {/* Coming Soon Overlay */}
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="text-center">
                  <div className="w-20 h-20 bg-goldAccent rounded-full flex items-center justify-center mb-4 mx-auto">
                    <Mic className="w-10 h-10 text-richBrown" />
                  </div>
                  <div className="text-warmCream font-bold text-xl mb-2">Coming Soon</div>
                  <div className="text-warmCream/80 text-sm">Stay Tuned</div>
                </div>
              </div>
            </div>
            
            {/* Decorative Elements */}
            <div className="absolute -top-4 -right-4 w-8 h-8 bg-goldAccent rounded-full"></div>
            <div className="absolute -bottom-4 -left-4 w-6 h-6 border-2 border-goldAccent rounded-full"></div>
          </div>
        </div>

        {/* Movement Stats */}
        <div className="mt-16 bg-lightBrown rounded-lg p-8">
          <div className="grid md:grid-cols-3 gap-8 text-center">
            <div>
              <div className="text-3xl font-black text-goldAccent mb-2">10K+</div>
              <div className="text-richBrown font-medium">Movement Members</div>
            </div>
            <div>
              <div className="text-3xl font-black text-goldAccent mb-2">∞</div>
              <div className="text-richBrown font-medium">Shades Celebrated</div>
            </div>
            <div>
              <div className="text-3xl font-black text-goldAccent mb-2">1</div>
              <div className="text-richBrown font-medium">Standard: Ours</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MediaSection;